/** 組織分類標記顏色設定 */
export const ORG_SORT_TAG_COLORS = [
  '#b689ff',
  '#d7beff',
  '#c6d7ff',
  '#7aaaff',
  '#4db2ff',
  '#40c7a4',
  '#32d9ae',
  '#ffc350',
  '#feb019',
  '#ff5f55',
  '#ffbbad',
  '#eebdec',
  '#a5abb3',
  '#bbc0c8'
] as const

export type OrgSortTagColor = (typeof ORG_SORT_TAG_COLORS)[number]

/** 組織分類標記字元上限 */
export const MAX_ORG_SORT_TAG_COUNT = 7

/** 組織分類標記顯示變體 */
export const ORG_SORT_TAG_VARIANTS = {
  /** 完整樣式（帶背景色） */
  DEFAULT: 'default',
  /** 簡潔樣式（無背景色，用於 dropdown） */
  COMPACT: 'compact',
  /** 標記樣式（帶邊框，可點擊） */
  TAG: 'tag'
} as const

export type OrgSortTagVariant = (typeof ORG_SORT_TAG_VARIANTS)[keyof typeof ORG_SORT_TAG_VARIANTS]

/** 組織分類標記樣式配置 */
export const ORG_SORT_TAG_STYLE_CONFIG = {
  [ORG_SORT_TAG_VARIANTS.DEFAULT]: {
    container: {
      base: 'h-6 rounded-xl px-2 py-0.5 text-app-black-900 bg-app-light-blue-50/40'
    },
    content: {
      base: 'flex items-center gap-1.5'
    },
    dot: {
      base: 'h-2.5 w-2.5 flex-shrink-0 rounded-[3px]'
    },
    text: {
      base: 'whitespace-nowrap pb-px text-sm leading-5 group-hover:text-app-brand-blue-500'
    }
  },
  [ORG_SORT_TAG_VARIANTS.COMPACT]: {
    container: {
      base: 'flex items-center gap-2 text-app-black-800'
    },
    content: {
      base: 'flex items-center gap-2'
    },
    dot: {
      base: 'h-2.5 w-2.5 flex-shrink-0 rounded-[3px]'
    },
    text: {
      base: 'whitespace-nowrap pb-px text-sm leading-5 group-hover:text-app-brand-blue-500'
    }
  },
  [ORG_SORT_TAG_VARIANTS.TAG]: {
    container: {
      base: 'flex h-8 items-center gap-1.5 px-3 py-2 border border-solid rounded-[30px] cursor-pointer',
      selected: 'bg-app-light-blue-50/40 border-app-brand-blue-500/40 text-app-brand-blue-500',
      unselected:
        'border-app-black-50 hover:border-app-brand-blue-500/40 hover:bg-app-light-blue-50/40 text-app-black-600'
    },
    content: {
      base: 'flex items-center gap-1.5'
    },
    dot: {
      base: 'h-2.5 w-2.5 flex-shrink-0 rounded-[3px]'
    },
    text: {
      base: 'whitespace-nowrap pb-px text-sm leading-5 group-hover:text-app-brand-blue-500'
    }
  }
} as const
